import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Output() languageChanged = new EventEmitter<string>();

  selectedLanguage: string = 'hu';
  menuOpen = false;

  onLanguageChange(lang: string) {
    this.selectedLanguage = lang;
    this.languageChanged.emit(lang);
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

}
